<template>
  <div class="locate-us__cta">
    <div class="locate-us__cta-btn">
      <div style="width: 80%" class="locate-us__cta-heading">
        <Heading level="3" style="color:#fff;margin:0;margin-bottom: 8px">
          {{ props.data?.cta_action?.cta_text }}
        </Heading>
      </div>
      <!-- <div class="locate-us__cta-description">
        <p
          v-html="props.data?.cta_action?.cta_description"
          style="color:#fff"
        ></p>
      </div> -->
      <div class="locate-us__cta-description" ref="descriptionElement">
      </div>
      <a
        :href="getLangUrl(props.data?.cta_action?.cta_button_link, baseUrl, locale)"
        class="locate-us__cta-btn-link"
        >{{ props.data?.cta_action?.cta_button_label }}</a
      >
    </div>
    <div class="locate-us__cta-banner">
      <img
        :src="props.data?.cta_action?.cta_banner?.url"
        :data-src="props.data?.cta_action?.cta_banner?.url"
        class="locate-us__cta-banner-img locate-us__cta-banner-img--desktop locate-us-lazy"
        alt="Locate us"
        loading="lazy"
      />

      <img
        :src="props.data?.cta_action?.cta_banner_mobile.url"
        :data-src="props.data?.cta_action?.cta_banner_mobile.url"
        class="locate-us__cta-banner-img locate-us__cta-banner-img--mobile locate-us-lazy"
        alt="Locate us"
        loading="lazy"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import Heading from '../Heading.vue';
const props = defineProps({
  data: Object
});

const runtimeConfig = useRuntimeConfig();
  const baseUrl = runtimeConfig.public.BASE_URL;
  import { useI18n } from 'vue-i18n';
  const { locale } = useI18n();
  import { getLangUrl } from '~/utils/getLangUrl';

// Create a ref for the description element
const descriptionElement = ref(null);

// Function to update the HTML content
const updateDescription = () => {
  if (descriptionElement.value && props.data?.cta_action?.cta_description) {
    descriptionElement.value.innerHTML = props.data.cta_action.cta_description;
    // Add the style directly if needed
    descriptionElement.value.style.color = '#fff';
  }
};

// Watch for changes in the props.data
watch(() => props.data, () => {
  updateDescription();
}, { deep: true });

// Also update on component mount
onMounted(() => {
  updateDescription();
});
</script>

<style lang="scss" scoped>
.locate-us__cta {
  display: flex;
  flex-direction: row;
  width: 100%;
  background: #b51f4f;
}
.locate-us__cta .locate-us__cta-btn {
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 345px;
  @media screen and (max-width: 992px) {
    margin:auto;
    margin-top: 20px;
        margin-bottom: 30px;
        width: 80%;
  }
}
.locate-us__cta-btn{
    .locate-us__cta-heading{
      text-align: left;
      @media screen and (max-width: 992px) {
        text-align: center;
      }
    }

  }
.locate-us__cta-btn .locate-us__cta-description {
  text-align: left;
  width: 80%;
}
.locate-us__cta-btn .locate-us__cta-description p {
  color: #fff;
  font-size: 14px;
}
.locate-us__cta-btn .locate-us__cta-btn-link {
  background: #fff;
  color: #b51f4f;
  font-size: 18.2px;
  border-radius: 8px;
  padding: 12px 15px 12px;
  font-weight: 600;
  width: 80%;
  max-width: 280px;
  text-align: center;
  text-decoration: none;

}
.locate-us__cta .locate-us__cta-banner {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-height: 280px;
}
.locate-us__cta-banner .locate-us__cta-banner-img {
  width: 100%;
  height: 280px;
  object-fit: cover;
}
.locate-us__cta-banner .locate-us__cta-banner-img--mobile {
  display: none;
}
@media screen and (max-width: 992px) {
    .locate-us__cta{
        flex-direction: column;
    }
    .locate-us__cta .locate-us__cta-btn {
        width: 100%;
    }
    .locate-us__cta-btn .locate-us__cta-btn-link {
        max-width: unset;
    }
    .locate-us__cta-btn h3 {
        text-align: center;
    }
    .locate-us__cta-btn .locate-us__cta-description {
        text-align: center;
    }
}
@media (max-width: 767px){
    .locate-us__header .locate-us__heading{
        margin-top: 5px;
    }
    .page-template-template-locate .map-left{
        max-height: unset;
    }
    .locate-us__loadmore-mobile{
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        padding-top: 15px;
        padding-left: 20px;
        padding-right: 20px;
    }
    .locate-us__loadmore-mobile .locate-us__loadmore-btn{
        padding: 14px 25px 11px;
        width: 100%;
        background: #ad073d;
        color: #fff;
        font-size: 20px;
        font-weight: 500;
        border-radius: 8px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    .locate-us__loadmore-mobile .locate-us__loadmore-btn.deactive{
        display: none;
    }
    .locate-us__loadmore-mobile .locate-us__loadmore-btn span{
        display: inline-block;
        line-height: 1;
    }
    .location-item.mobile-deactive{
        display: none;
    }
    .locate-us__bottom-section{
        padding: 0;
    }
    .locate-us__bottom-section .text-center{
        padding: 0 5px;
    }
    .locate-us__cta{
        flex-direction: column-reverse;
    }
    .locate-us__cta-banner .locate-us__cta-banner-img--mobile{
        display: block;
    }
    .locate-us__cta-banner .locate-us__cta-banner-img--desktop{
        display: none;
    }
}
</style>
<!-- </style> -->